import { defineStore } from 'pinia'
import { getTestimonialsForRecipient } from '@app/api'

export const useTestimonialForRecipientStore = defineStore('TestimonialForRecipientStore', {
  state: () => ({
    testimonials: [],
  }),

  actions: {
    async fetch(recipientId, caseStudyId) {
      getTestimonialsForRecipient(recipientId, caseStudyId).then((response) => {
        this.testimonials = response.data.testimonials
      })
    },
  },
})
